export interface IGoToLocalInfo {
    target_region?: string
    target_location?: string
    global_id_validations?: Map<string, GlobalIdValidation>
    sessionCreated: boolean
    gtlSessionRedirectURL?: string
    references: {
        [id: string]: {
            [region: string]: {
                [location: string]: {
                    url: string
                    website: string
                    locale: string
                }
            }
        }
    }
}

export enum GlobalIdValidation {
    Valid = 'VALID',
    Invalid = 'INVALID',
}


